import { memo, useCallback, useMemo } from "react";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { SelectField } from "@/components/ui/form/fields/select-field";

import type { FilterInSaleAndStopSellingProps } from "../../type";

export const FilterInSaleAndStopSellingForMobile = memo(
	({
		isPending,
		itemsName,
		selectedItemIDs,
		onChangeSelectedItemIDs,
		inSaleItems,
		stopSellingItems,
	}: FilterInSaleAndStopSellingProps) => {
		const handleValueChange = useCallback(
			(value: string) => {
				onChangeSelectedItemIDs([value]);
			},
			[onChangeSelectedItemIDs],
		);

		const options: FormOptionType[] = useMemo(
			() => [
				...inSaleItems.map((item, idx) => {
					return {
						id: `inSaleItems-${idx}`,
						label: item.name,
						value: item.id,
					} satisfies FormOptionType;
				}),
				...stopSellingItems.map((item, idx) => {
					return {
						id: `stopSellingItems-${idx}`,
						label: item.name,
						value: item.id,
					} satisfies FormOptionType;
				}),
			],
			[inSaleItems, stopSellingItems],
		);

		// inSaleItems が存在するかどうか
		const isInSaleItemsExist = inSaleItems.length > 0;
		// stopSellingItems が存在するかどうか
		const isStopSellingItemsExist = stopSellingItems.length > 0;

		// inSaleItems と stopSellingItems のいずれかでも存在する場合
		const isEitherInSaleItemsOrStopSellingItemsExist = isInSaleItemsExist || isStopSellingItemsExist;

		return (
			<>
				{isEitherInSaleItemsOrStopSellingItemsExist && (
					<div className="space-y-2">
						<h5 className="font-semibold">表示する{itemsName}</h5>
						<SelectField
							disabled={isPending}
							value={selectedItemIDs[0]}
							options={options}
							handleValueChange={handleValueChange}
						/>
					</div>
				)}
			</>
		);
	},
);

FilterInSaleAndStopSellingForMobile.displayName = "FilterInSaleAndStopSellingForMobile";
